import { z } from "zod";

// Esquema de validação regras e mensagens de erro
export const schema = z
	.object({
		id_funcionario: z.number().int("Verifique o id_colaborador antes de continuar"),
		id_tipocolaborador: z.number().int(),
		nome: z
			.string()
			.min(3, "Por favor, informe o nome do cliente, no mínimo 3 caracteres")
			.refine((value) => value.trim().length > 0, {
				message: "O campo nome não pode conter apenas espaços em branco",
			}),
		rua: z.string().nullable(),
		// .refine((value) => value.trim().length > 0, {
		// 	message: "O campo nome não pode conter apenas espaços em branco",
		// }),
		bairro: z.string().nullable(),
		numero: z.union([z.string(), z.null()]),
		// .refine((value) => value.length > 0 && value.trim().length === 0, {
		// 	message: "O campo nome não pode conter apenas espaços em branco",
		// }),
		complemento: z.string().nullable(),
		id_cidade: z.coerce
			.number({ invalid_type_error: "Selecione uma cidade" }) // Converte o valor para número
			.int("O campo id_cidade deve ser um número inteiro.") // Valida que é inteiro
			.refine((val) => val > 0, {
				// Garante que seja maior que 0
				message: "Selecione uma cidade válida",
			}),
		telefone_1: z.string().nullable(),
		telefone_2: z.string().nullable(),
		cpf: z.string().nullable(),
		rg: z.string().nullable(),
		cep: z.string().nullable(),
		pessoafisica: z.boolean(),
		ativo: z.boolean(),
		sexo: z.string().nullable(),
		data: z.string(),
		email_contato: z.lazy(() => z.string().email("Digite um e-mail válido").nullable().or(z.literal(""))),
		email: z.lazy(() => z.string().email("Digite um e-mail válido").nullable().or(z.literal(""))),
		// senha: z.string().min(6, "A senha deve conter no mínimo 6 caracteres"),
		obs: z.string().nullable(),

		tipo: z
			.string()
			.nullable()
			.transform((val) => {
				return val ? val.toUpperCase() : val;
			}),
		permissoes: z
			.object({
				id_permissao: z.number().int("Verifique o id_permissao antes de continuar"),
				id_funcionario: z.number().int("Verifique o id_colaborador antes de continuar"),
				cad_permissao: z.boolean(),
				cad_empresa: z.boolean(),
				cad_cliente: z.boolean(),
				// cad_tipo_cliente: z.boolean(),
				cad_colaborador: z.boolean(),
				// cad_tipo_colaborador: z.boolean(),
				cad_produto: z.boolean(),
				// cad_tipo_produto: z.boolean(),
				cad_fornecedor: z.boolean(),
				cad_financeiro: z.boolean(),
				// cad_centro_custo: z.boolean(),
				// cad_conta: z.boolean(),
				// cad_tipo_conta: z.boolean(),
				cad_conta_entrada: z.boolean(),
				cad_conta_saida: z.boolean(),
				mov_caixa: z.boolean(),
				pdv_cancelar_pre_venda: z.boolean(),
				pdv_excluir_item: z.boolean(),
				pdv_salvar_vale: z.boolean(),
				relatorios: z.boolean(),
				fiscal: z.boolean(),
				boleto: z.boolean(),
				marketing: z.boolean(),
			})
			.nullable(),
	})
	.refine((data) => !(data.rua && data.rua.trim().length > 0) || (data.numero && data.numero.trim().length > 0), {
		message: "Campo número é obrigatório se a rua estiver preenchida",
		path: ["numero"],
	})
	.refine((data) => !(data.numero && data.numero.trim().length > 0) || (data.rua && data.rua.trim().length > 0), {
		message: "Campo rua é obrigatório se o número estiver preenchido",
		path: ["rua"],
	});

export const schemaDefaultValue = {
	id_funcionario: 0,
	id_tipocolaborador: 1,
	nome: "",
	rua: "",
	numero: "",
	complemento: "",
	bairro: "",
	id_cidade: 0,
	telefone_1: "",
	telefone_2: "",
	cpf: "",
	rg: "",
	cep: "",
	pessoafisica: true,
	ativo: true,
	sexo: "",
	data: "",
	email_contato: "",
	email: "",
	// senha: "",
	tipo: "",
	obs: "",
	permissoes: {
		id_permissao: 0,
		id_funcionario: 0,
		cad_empresa: false,
		cad_permissao: false,
		cad_cliente: false,
		cad_colaborador: false,
		cad_produto: false,
		cad_fornecedor: false,
		cad_financeiro: false,
		cad_centro_custo: false,
		cad_conta: false,
		cad_conta_entrada: false,
		cad_conta_saida: false,
		mov_caixa: false,
		pdv_cancelar_pre_venda: false,
		pdv_excluir_item: false,
		pdv_salvar_vale: false,
		relatorios: false,
		fiscal: false,
		boleto: false,
		marketing: false,
	},
};
